import React from "react";
import { Helmet } from "react-helmet";
import Skelet from "../components/fotoSkelet";
import { Link } from "gatsby";
import Layout from "../components/layout";


const Vanoce = () => {






  const photoList = [
    {
      id: 1,
      style: "col-4",
      preview: "vanocni/n/1.webp",
      full: "vanocni/f/1.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 2,
      style: "col-4",
      preview: "vanocni/n/2.webp",
      full: "vanocni/f/2.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 3,
      style: "col-4",
      preview: "vanocni/n/3.webp",
      full: "vanocni/f/3.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 4,
      style: "col-12",
      preview: "vanocni/n/4.webp",
      full: "vanocni/f/4.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 5,
      style: "col-12",
      preview: "vanocni/n/5.webp",
      full: "vanocni/f/5.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 6,
      style: "col-12",
      preview: "vanocni/n/6.webp",
      full: "vanocni/f/6.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 7,
      style: "col-12",
      preview: "vanocni/n/7.webp",
      full: "vanocni/f/7.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 8,
      style: "col-12",
      preview: "vanocni/n/8.webp",
      full: "vanocni/f/8.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 9,
      style: "col-12",
      preview: "vanocni/n/9.webp",
      full: "vanocni/f/9.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 10,
      style: "col-12",
      preview: "vanocni/n/10.webp",
      full: "vanocni/f/10.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 11,
      style: "col-12",
      preview: "vanocni/n/11.webp",
      full: "vanocni/f/11.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 12,
      style: "col-12",
      preview: "vanocni/n/12.webp",
      full: "vanocni/f/12.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 13,
      style: "col-12",
      preview: "vanocni/n/13.webp",
      full: "vanocni/f/13.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 14,
      style: "col-12",
      preview: "vanocni/n/14.webp",
      full: "vanocni/f/14.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 15,
      style: "col-4",
      preview: "vanocni/n/15.webp",
      full: "vanocni/f/15.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 16,
      style: "col-4",
      preview: "vanocni/n/16.webp",
      full: "vanocni/f/16.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 17,
      style: "col-4",
      preview: "vanocni/n/17.webp",
      full: "vanocni/f/17.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 18,
      style: "col-12",
      preview: "vanocni/n/18.webp",
      full: "vanocni/f/18.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 19,
      style: "col-12",
      preview: "vanocni/n/19.webp",
      full: "vanocni/f/19.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 20,
      style: "col-12",
      preview: "vanocni/n/20.webp",
      full: "vanocni/f/20.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 21,
      style: "col-12",
      preview: "vanocni/n/21.webp",
      full: "vanocni/f/21.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 22,
      style: "col-12",
      preview: "vanocni/n/22.webp",
      full: "vanocni/f/22.jpg",
      alt: "porfolio fotka vánočního focení",
    },
    {
      id: 23,
      style: "col-12",
      preview: "vanocni/n/23.webp",
      full: "vanocni/f/23.jpg",
      alt: "porfolio fotka vánočního focení",
    }
  ];


  const helmetElement = (
    <Helmet>
      <title>Vánoční focení | Martin Petrovický | Foto a video</title>
      <meta
        name="description"
        content="Ukázka plesových fotografií a videí."
      />
      <meta
        name="keywords"
        content="Ples, Maturita, fotograf, kameraman, maturitní video, maturitní fotograf, plesový kameraman, maturitní kameraman, prom"
      />
      <meta name="author" content="Martin Petrovický" />
    </Helmet>
  );

  return (
    <Layout>
      <main>
        {helmetElement}
        <div className="container">
          <div className="text-center h1 mt-2 mt-md-5 mb-4">Vánoční focení</div>

          <div className="pb-2 pb-md-5">
            <Skelet photoList={photoList} />
          </div>

          <div className="row py-5 text-center">
            <div className="col-12 col-lg-6 text-left">
              <h2 className="mb-3 ml-0 ml-lg-3">JAKÉ FOTKY OBDRŽÍTE?</h2>
              <ul className="list-dots">
                <li className="my-2">30 miminut focení v ateliéru</li>
                <li>V rámci balíčku vybíráte alespoň ze 100 fotografií</li>
                <li className="my-2">Obdžíte 5 upravených fotografií v digitální podobě dle vlastního výběru</li>
                <li>Každá další fotografie 200 kč</li>
                <li className="my-2">Upravené fotografie připravené pro sociální sítě a v plném rozlišení pro tisk</li>
              </ul>
            </div>

            <div className="col-12 col-lg-6">
              <h2 className="mb-3">CENA</h2>
              <p className="my-0 my-md-4" style={{ fontSize: '140%' }}>1 200 Kč</p>
              <Link to="/kontakt">
                <div className="btn btn-svatby rounded-0 border border-dark border-end-0 border-start-0 mt-3 mb-5">
                  Napište mi
                </div>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default Vanoce;
